import type { ClassInfo, Student } from './types';

export const MOCK_CLASSES: ClassInfo[] = [
  { id: 'cls1', name: 'Class 6',  section: 'A', studentCount: 32 },
  { id: 'cls2', name: 'Class 6',  section: 'B', studentCount: 30 },
  { id: 'cls3', name: 'Class 7',  section: 'A', studentCount: 35 },
  { id: 'cls4', name: 'Class 7',  section: 'B', studentCount: 33 },
  { id: 'cls5', name: 'Class 8',  section: 'A', studentCount: 31 },
  { id: 'cls6', name: 'Class 9',  section: 'A', studentCount: 28 },
  { id: 'cls7', name: 'Class 10', section: 'A', studentCount: 29 },
];

export const MOCK_STUDENTS: Record<string, Student[]> = {
  cls1: [
    { id: 's001', name: 'Aarav Kumar',      rollNo: '01' },
    { id: 's002', name: 'Priya Singh',       rollNo: '02' },
    { id: 's003', name: 'Rohit Sharma',      rollNo: '03' },
    { id: 's004', name: 'Sneha Verma',       rollNo: '04' },
    { id: 's005', name: 'Aditya Gupta',      rollNo: '05' },
    { id: 's006', name: 'Kavya Patel',       rollNo: '06' },
    { id: 's007', name: 'Vikram Yadav',      rollNo: '07' },
    { id: 's008', name: 'Anjali Mishra',     rollNo: '08' },
    { id: 's009', name: 'Rahul Tiwari',      rollNo: '09' },
    { id: 's010', name: 'Pooja Jha',         rollNo: '10' },
    { id: 's011', name: 'Arjun Pandey',      rollNo: '11' },
    { id: 's012', name: 'Neha Sinha',        rollNo: '12' },
    { id: 's013', name: 'Karan Dubey',       rollNo: '13' },
    { id: 's014', name: 'Divya Chauhan',     rollNo: '14' },
    { id: 's015', name: 'Saurabh Raj',       rollNo: '15' },
    { id: 's016', name: 'Meera Devi',        rollNo: '16' },
    { id: 's017', name: 'Harsh Agrawal',     rollNo: '17' },
    { id: 's018', name: 'Ananya Shukla',     rollNo: '18' },
    { id: 's019', name: 'Yash Srivastava',   rollNo: '19' },
    { id: 's020', name: 'Ritika Bhatt',      rollNo: '20' },
  ],
  cls2: [
    { id: 's101', name: 'Amit Choubey',    rollNo: '01' },
    { id: 's102', name: 'Sunita Kumari',   rollNo: '02' },
    { id: 's103', name: 'Deepak Nishad',   rollNo: '03' },
    { id: 's104', name: 'Riya Pandey',     rollNo: '04' },
    { id: 's105', name: 'Nikhil Oraon',    rollNo: '05' },
    { id: 's106', name: 'Shreya Mahto',    rollNo: '06' },
    { id: 's107', name: 'Vishal Sahu',     rollNo: '07' },
    { id: 's108', name: 'Pinki Devi',      rollNo: '08' },
    { id: 's109', name: 'Sanjay Munda',    rollNo: '09' },
    { id: 's110', name: 'Tanvi Lakra',     rollNo: '10' },
    { id: 's111', name: 'Anand Kishore',   rollNo: '11' },
    { id: 's112', name: 'Renu Bala',       rollNo: '12' },
  ],
  cls3: [
    { id: 's201', name: 'Akash Giri',        rollNo: '01' },
    { id: 's202', name: 'Shweta Nayak',      rollNo: '02' },
    { id: 's203', name: 'Manish Tigga',      rollNo: '03' },
    { id: 's204', name: 'Pallavi Rout',      rollNo: '04' },
    { id: 's205', name: 'Suraj Hembram',     rollNo: '05' },
    { id: 's206', name: 'Kajal Sarkar',      rollNo: '06' },
    { id: 's207', name: 'Rajan Ekka',        rollNo: '07' },
    { id: 's208', name: 'Nidhi Kullu',       rollNo: '08' },
    { id: 's209', name: 'Pramod Bilung',     rollNo: '09' },
    { id: 's210', name: 'Sonia Minz',        rollNo: '10' },
  ],
  cls4: [
    { id: 's301', name: 'Tarun Baraik',      rollNo: '01' },
    { id: 's302', name: 'Laxmi Tudu',        rollNo: '02' },
    { id: 's303', name: 'Gautam Mardi',      rollNo: '03' },
    { id: 's304', name: 'Poonam Hansda',     rollNo: '04' },
    { id: 's305', name: 'Bibek Murmu',       rollNo: '05' },
    { id: 's306', name: 'Champa Soren',      rollNo: '06' },
    { id: 's307', name: 'Dilip Kisku',       rollNo: '07' },
    { id: 's308', name: 'Rina Besra',        rollNo: '08' },
  ],
  cls5: [
    { id: 's401', name: 'Rupesh Mahali',     rollNo: '01' },
    { id: 's402', name: 'Geeta Bhumij',      rollNo: '02' },
    { id: 's403', name: 'Santosh Lohar',     rollNo: '03' },
    { id: 's404', name: 'Basanti Kudada',    rollNo: '04' },
    { id: 's405', name: 'Subhash Chandra',   rollNo: '05' },
    { id: 's406', name: 'Sabita Naik',       rollNo: '06' },
    { id: 's407', name: 'Jitendra Birua',    rollNo: '07' },
    { id: 's408', name: 'Mamta Gorai',       rollNo: '08' },
    { id: 's409', name: 'Ashok Majhi',       rollNo: '09' },
  ],
  cls6: [
    { id: 's501', name: 'Rajesh Bhengra',    rollNo: '01' },
    { id: 's502', name: 'Savitri Tete',      rollNo: '02' },
    { id: 's503', name: 'Naresh Kandulna',   rollNo: '03' },
    { id: 's504', name: 'Dulari Munda',      rollNo: '04' },
    { id: 's505', name: 'Birendra Topno',    rollNo: '05' },
    { id: 's506', name: 'Radha Khalkho',     rollNo: '06' },
  ],
  cls7: [
    { id: 's601', name: 'Sunil Kachhap',     rollNo: '01' },
    { id: 's602', name: 'Sarita Dungdung',   rollNo: '02' },
    { id: 's603', name: 'Mahendra Baxla',    rollNo: '03' },
    { id: 's604', name: 'Asha Lakra',        rollNo: '04' },
    { id: 's605', name: 'Binod Kiro',        rollNo: '05' },
    { id: 's606', name: 'Kamla Xalxo',       rollNo: '06' },
    { id: 's607', name: 'Arun Kullu',        rollNo: '07' },
  ],
};

export function getStudentsForClass(classId: string): Student[] {
  return (MOCK_STUDENTS[classId] ?? []).map(s => ({ ...s, attendance: null }));
}
